























































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UserStore } from '@/store/modules/User'
import { city } from '@/api/com'
import { relationUsrs, relationCreate, fastCreate } from '@/api/relation'

@Component({
  name: 'CreateRelation'
})
export default class CreateRelation extends Vue {
  @Prop({
    type: Boolean,
    default: false
  }) value!: boolean;

  // 所点击的绑定数据
  @Prop({
    type: Object,
    default: () => ({})
  }) bindData!: any

  get userInfo () {
    return UserStore.userInfo
  }

  get createShow (): boolean {
    return this.value
  }

  set createShow (newData: boolean) {
    this.handleValue(newData)
  }

  loading = false

  operation = 0; // 默认为0 就是初始选择 一键绑定 还是 手工绑定  1 就是手工绑定界面

  props = {
    lazy: true,
    lazyLoad (node, resolve) {
      const { level } = node
      const params = {
        parentId: node.value || 0
      }
      city(params)
        .then(res => {
          const nodes = res.map(item => {
            return {
              value: item.areaId,
              label: item.treeName,
              leaf: level >= 2
            }
          })
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(nodes)
        })
    }
  }

  // 用户选中的城市
  cityValue: any[] = []

  // 供应商信息
  cust: any = {
    custName: '',
    supplierId: ''
  }

  // 分销商账户
  distributorId = ''

  // 分销商密码
  distributorPwd = ''

  @Emit('input')
  handleValue (newData: boolean): boolean {
    return newData
  }

  // 一键绑定
  getfastCreate () {
    this.loading = true
    const params = {
      syncParentCustId: this.bindData.parentMchId,
      syncdbLink: this.bindData.dbLink
    }
    fastCreate(params)
      .then(res => {
        this.loading = false
        if (res.success) {
          this.$message({
            type: 'success',
            showClose: true,
            message: res.msg
          })
          const dataInfo = res.data
          const htmlStr = `
            <p style="color: red;font-size:16px;margin-bottom:10px;">第一时间登录账户修改密码并妥善保管</p>
            <p>分销商ID: ${dataInfo.orderCustId}</p>
            <p>分销商密码: ${dataInfo.orderCustPassword}</p>
            <p>供应商ID: ${dataInfo.supplierCustId}</p>
            <p>供应商密码: ${dataInfo.supplierCustPassword}</p>
          `
          this.$alert(htmlStr, '请自主复制保存账户密码！', {
            showClose: false,
            dangerouslyUseHTMLString: true,
            confirmButtonText: '我已复制并保存'
          })
          this.handleFastCreate()
          this.createShow = false
        } else {
          this.$message({
            type: 'error',
            showClose: true,
            message: res.msg
          })
        }
      }).catch(err => {
        try {
          this.$message({
            type: 'error',
            showClose: true,
            message: String(err)
          })
        } catch (err) { }
        this.loading = false
      })
  }

  // 一键绑定成功
  @Emit('fastCreate')
  handleFastCreate () {
    return ''
  }

  // 弹框关闭前回调
  beforeClose (done): void {
    this.operation = 0
    done()
  }

  getRelationUsrs (callback) {
    const params = {
      areaId: this.cityValue[this.cityValue.length - 1] || '',
      custName: this.cust.custName || ''
    }
    relationUsrs(params)
      .then(res => {
        callback(res)
      })
  }

  // 输入搜索
  querySearchAsync (queryString, callback) {
    // this.$set(this.cust, 'custName', queryString)
    this.cust.custName = queryString
    if (queryString) {
      this.getRelationUsrs(callback)
    }
  }

  // 选中搜索出来的供应商
  handleSelectCustName (item) {
    this.cust.custName = item.custName
    this.cust.supplierId = item.custId
  }

  // 建立串货关系
  onCreateRelation () {
    console.log('建立串货关系')
    const params = {
      distributorId: this.distributorId,
      distributorPwd: this.distributorPwd,
      supplierId: this.cust.supplierId,
      syncCustId: this.bindData.parentMchId,
      syncdbLink: this.bindData.dbLink
    }
    console.log(params)
    relationCreate(params)
      .then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            showClose: true,
            message: res.msg
          })
          this.handleFastCreate()
          this.createShow = false
        } else {
          this.$message({
            type: 'error',
            showClose: true,
            message: res.msg
          })
        }
      })
  }
  // mounted (): void { }
}
